const SearchConditionMinxin = {
  data() {
    return {
      selectedKeys: [],
    }
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {
    getBoxKey(key) {
      let boxKey = '';
      this.initSearchCondition.forEach((item) => {
        if (item.box) {
          item.box.forEach((itemBox) => {
            if (itemBox.list) {
              itemBox.list.forEach((itemBoxList) => {
                if (itemBoxList.items) {
                  itemBoxList.items.forEach((ite) => {
                    if (ite.key === key) {
                      console.log('item---',item,'item.key--',item.key)
                      boxKey = item.key
                    }
                  })
                }
              })
            }
          })
        }
      })
      return boxKey
    },
    inTheSameBoxIndex(boxKey) {
      return this.selectedKeys.findIndex((keyItem) => {
        return keyItem.boxKey === boxKey
      })
    },
    onConditionSelected(item, checked) {
      const currKeyItem = this.selectedKeys.find((keyItem) => {
        return keyItem.key === item.key
      })
      const boxKey = this.getBoxKey(item.key);
      const saveBoxIndex = this.inTheSameBoxIndex(boxKey);
      const keyItem = {
        key: item.key,
        boxKey: boxKey,
        item:item
      };
      if (checked && !currKeyItem) {
        // 看看是否在同一个 box 层级
        console.log(saveBoxIndex, '<saveBoxIndex')
        if (saveBoxIndex > -1) {
          this.selectedKeys.splice(saveBoxIndex, 1, keyItem)
        } else {
          this.selectedKeys.push(keyItem)
        }

      }
      if (!checked && currKeyItem) {
        this.selectedKeys.splice(this.selectedKeys.findIndex((item) => {
          return item.key === key
        }), 1)
      }
    },
    onActiveItem(key) {
      let hasActive = false;
      this.initSearchCondition = this.initSearchCondition.map((item) => {
        console.log("onActiveItem--》",item.key)
        console.log("onActiveItem--》",item)
        if (key === item.key) {
          item.open = !item.open
        } else {
          item.open = false
        }
        console.log(item.open)
        if (item.open) {
          hasActive = true
        }
        return item;
      })
      // 显示隐藏列表 hasActive: 是显示还是隐藏  false 显示， true 隐藏
      this.toogleListShow && this.toogleListShow(hasActive)
    }

  }
}

export default SearchConditionMinxin
